import axios from "axios";
import config from "../config.json";

const baseURL = config.ADMIN_API_BASE_URL;
const concludedUrl = baseURL.startsWith("http")
  ? baseURL
  : `${window.location.protocol}//${window.location.hostname}/api${baseURL}`;

const axiosInstance = axios.create({
  baseURL: concludedUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

export enum TwoFactorMethod {
  EMAIL = "EMAIL",
  TOTP = "TOTP",
  WHATSAPP = "WHATSAPP",
}

export const userPasswordLogin = async (
  email: string,
  password: string
): Promise<ILoginRepsonse> => {
  try {
    const response = await axiosInstance.post("/users/login", {
      email,
      password,
    });
    return response.data as ILoginRepsonse;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "An error occurred during login."
    );
  }
};

export const userOtpSelect = async (
  uuid: string,
  method: TwoFactorMethod
): Promise<ILoginRepsonse> => {
  try {
    // backend curl shows query params + body; we mirror that for compatibility
    const response = await axiosInstance.post(
      `/auth/otp/select?uuid=${encodeURIComponent(uuid)}&method=${encodeURIComponent(
        method
      )}`,
      { uuid, method }
    );
    return response.data as ILoginRepsonse;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "An error occurred while selecting OTP method."
    );
  }
};

export const userOtpVerify = async (
  uuid: string,
  otp: string,
  method: TwoFactorMethod
): Promise<ILoginRepsonse> => {
  try {
    const response = await axiosInstance.post("/auth/otp/verify", {
      uuid,
      otp,
      method,
    });
    return response.data as ILoginRepsonse;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "An error occurred while verifying OTP."
    );
  }
};

export const userRefreshTokenLogin = async (
  refreshToken: string
): Promise<ILoginRepsonse> => {
  try {
    const response = await axiosInstance.post("/users/login", {
      refreshToken,
    });
    return response.data as ILoginRepsonse;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred during refreshing the token."
    );
  }
};

export interface ILoginRepsonse {
  // login / select / verify meta
  requiresOtp?: boolean;
  uuid?: string;
  availableMethods?: TwoFactorMethod[];
  method?: TwoFactorMethod;
  validMethod?: boolean;

  // OTP messaging
  message?: string;
  otpExpiresInSeconds?: number;

  // token response
  access_token?: string;
  expires_in?: number;
  refresh_expires_in?: number;
  refresh_token?: string;
  token_type?: "Bearer";
  session_state?: string;
  scope?: string | null;

  // error response
  error?: string | null;
  error_description?: string | null;
  error_uri?: string | null;
}
